// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.spacing-header{padding-bottom:clamp(1.25rem,-2.22rem + 5.56vw,4.375rem);padding-top:clamp(1.25rem,-2.22rem + 5.56vw,4.375rem);width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
